<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2poUFh/tc-custom/9781468306019.jpg?1705201909904" alt="This image is the cover for the book Empire of Tea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Empire of Tea
      </h1>
      <p class="bookDescription body article font2">
        <b>This cultural, political, and social history of tea presents a “</b><b>fascinating picture of tea's impact on the lives of millions of people around the world.” (<i>Publishers Weekly)</i></b><br/>  <br/> From Darjeeling to Lapsang Souchon, from India to Japan—a fresh, concise, world-encompassing exploration of the way tea has shaped politics, culture, and the environment throughout history. From the fourth century BC in China, where it was used as an aid in Buddhist meditation, to the Boston Tea Party in 1773, to its present-day role as the most consumed substance on the planet, the humble Camellia plant has had profound effects on civilization. Renowned cultural anthropologist Alan MacFarlane and Iris MacFarlane recount the history of tea from its origin in the eastern Himalayas and explains, among other things, how tea became the world's most prevalent addiction, how tea was used as an instrument of imperial control, and how the cultivation of tea drove the industrial revolution. Both an absorbing narrative and a fascinating tour of some of the world's great cultures—Japan, China, India, France, Britain, and others—<i>The Empire of Tea</i> brings into sharp focus one of the forces that shaped history.<br/>  <br/> "A good primer on a resonant and endlessly stimulating subject.” —<i>Boston Sunday Globe</i><br/>  <br/> “A fascinating picture of tea's impact on the lives of millions of people around the world.” —<i>Publishers Weekly</i><br/>  <br/> “An absorbing read.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Macfarlane, Iris MacFarlane
      </h2>
      
      <p class="authorDescription body article">Alan Macfarlane was born in Shillong, Assam, India in December 1941, son of a tea-planter, and educated at the Dragon School, Oxford, Sedbergh School Yorkshire. He became a Senior Research Fellow at King's College, Cambridge in 1971 and a Lecturer, then Reader, then Professor of Anthropology at Cambridge. He became a Fellow of the British Academy in 1986 and is currently Emeritus Professor of Anthropological Science and Life Fellow of King's College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e57e1892